<template>
  <div id="cup_team" v-show="currThemeObj">
    <div class="abs_topArea">球 队</div>
    <template v-if="showSelectCidArr.includes(currCid)">
      <div class="select_area">
        <marathon_select_opt
          :currThemeObj="currThemeObj"
          :data="selectOptData"
          @changeSelectEvent="changeSelect"
        ></marathon_select_opt>
      </div>
    </template>
    <div class="teamList_area" v-if="!isNotDataFlag">
      <cup_cardList
        :currThemeObj="currThemeObj"
        :list="cup_teamList"
        :currCid="currCid"
        :currSid="currSid"
        mode="teamData"
      ></cup_cardList>
    </div>
    <cup_notData v-if="isNotDataFlag"></cup_notData>
  </div>
</template>

<script>
// import matchList_mock from './matchList_mock.json'
import {
  https_cup_teamGroup,
  https_cup_leagueTableStage,
} from '@api/platfrom_football_api'
import { https_seasonCup_teamList } from '@api/platfrom_basketball_api'
import cup_base_data_mixin from '@mixins/cup_base_data'
import cup_notData from '@components/base/NO_DATA.vue'
import cup_cardList from '@components/platfromBase/football/cup_cardList.vue'
import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'
export default {
  name: 'cup_team',
  mixins: [cup_base_data_mixin],
  components: {
    cup_cardList,
    cup_notData,
    marathon_select_opt,
  },
  data() {
    return {
      showSelectCidArr: ['112'],
      basketballCupCidArr: ['202', '203'],
      currStageEvent: null,
      stageArr: [],
      selectOptData_origin: {
        configArr: [
          {
            type: 'stage',
            title: '阶段',
            origin_keyVal: ['stageId', 'stageName'], // 源数据list [唯一id, 需要展示文字]
            dataName: 'stageArr', //this下面的存储该数据list字段名
            selectIndex: 0,
          },
        ],
        selectOpt_list: [],
      },
      selectOptData: null,
      cup_teamList: [],
      isNotDataFlag: false,
    }
  },
  created() {
    console.debug('this.currThemeObj:', this.currThemeObj)
    if (this.currGroup) {
      console.debug('init ')
      this.init()
    }
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      if (this.showSelectCidArr.includes(this.currCid)) {
        this.selectOptData = JSON.parse(
          JSON.stringify(this.selectOptData_origin)
        )
        await this.getParstage()
        this.computedSelectOpt(this.selectOptData.configArr)
      }
      this.autoChangeTeamGroup()

      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async autoChangeTeamGroup() {
      if (this.basketballCupCidArr.includes(this.currCid)) {
        // 篮球杯赛
        await this.getBasketballTeamGroup(this.currStageEvent)
      } else {
        // 足球杯赛
        await this.getTeamGroup(this.currStageEvent)
      }
    },
    computedSelectOpt(configArr) {
      // 组装选择框数据
      let selectOpt_list = []
      configArr.forEach((config, index) => {
        let disabledArr = []
        const mix_id = `mix_${config.origin_keyVal[0]}`
        let list = []
        if (config.isDatePicker) {
          // 日期选择框没有 dataName 属性
          selectOpt_list.push({
            type: config.type,
            title: config.title,
            keyVal: [mix_id, config.origin_keyVal[1]],
            curId: mix_id, //list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
            curVal: this.currStageMatchDate ? this.currStageMatchDate : '', // 这个值是源数据需要展示的值，没有做过修改
            disabledArr,
            list,
            isDatePicker: config.isDatePicker,
          })
        } else {
          list = this[config.dataName].map((item) => {
            item[mix_id] = `${config.type}_${item[config.origin_keyVal[0]]}`
            return item
          })
          console.debug(
            'computedSelectOpt 11:',
            config.type,
            config.dataName,
            this[config.dataName],
            list,
            mix_id
          )
          selectOpt_list.push({
            type: config.type,
            title: config.title,
            keyVal: [mix_id, config.origin_keyVal[1]],
            curId: list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
            curVal: list[config.selectIndex][config.origin_keyVal[1]], // 这个值是源数据需要展示的值，没有做过修改
            disabledArr, //当【阶段】选择为淘汰赛时，球队这栏置灰；所以在【球队】这组对象的disabledArr=['stage_2']；而【阶段】的disabledArr = []。在marathon_select_opt组件中也需要做一些逻辑处理，主要是对curStageVal这个值
            isFilterable: config.isFilterable ? config.isFilterable : false,
            list,
          })
        }
      })

      this.selectOptData.selectOpt_list = selectOpt_list
      console.debug('this.selectOptData.selectOpt_list', selectOpt_list)
    },
    async changeSelect(data) {
      console.debug('changeSelect:', data)
      let valPathArr = []
      let val = data.val
      // 选择后，重置联动的筛选框
      let updateSelectIndex = -1
      if (data.type === 'select') {
        if (val.indexOf('_') > -1) {
          valPathArr = val.split('_')
          for (let i = 0; i < this.selectOptData.selectOpt_list.length; i++) {
            let item = this.selectOptData.selectOpt_list[i]
            const idKey = item.keyVal[0]
            const valKey = item.keyVal[1]
            if (item.type == valPathArr[0]) {
              for (let j = 0; j < item.list.length; j++) {
                let cell = item.list[j]
                console.debug(idKey, val)
                if (cell[idKey] == val) {
                  console.debug(cell[idKey], val)
                  updateSelectIndex = i
                  item.curVal = cell[valKey]
                  break
                }
              }
            }
          }
          if (valPathArr[0] === 'stage') {
            this.currStageEvent = valPathArr[1]
            window.mixtmtBase_eventBus.$emit('loadingEvent', true)
            await this.autoChangeTeamGroup()
          }

          window.mixtmtBase_eventBus.$emit('loadingEvent', false)
        } else {
          console.debug('id命名方式不符合组件规则')
        }
      } else {
        console.debug('data.type 没有匹配成功')
      }
    },
    async getParstage() {
      await https_cup_leagueTableStage(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
        cid: this.currCid,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            const stageArr = res.data && res.data.length > 0 ? res.data : []
            // this.stageArr = [].concat(
            //   [
            //     {
            //       stageId: '-1',
            //       stageName: '全部',
            //     },
            //   ],
            //   stageArr
            // )
            this.stageArr = stageArr
            this.currStageEvent =
              this.stageArr[this.selectOptData.configArr[0].selectIndex].stageId
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getTeamGroup(stageCode) {
      let params = {
        sid: this.currSid,
        cid: this.currCid,
      }
      if (stageCode) {
        params.stageCode = stageCode
      }
      await https_cup_teamGroup(this.axiosBaseUrl, this.$axios, params)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            if (!res.data || (res.data && res.data.length == 0)) {
              this.isNotDataFlag = true
            }
            this.cup_teamList = res.data
              ? res.data.map((val) => {
                  return {
                    title: val.seriesName,
                    key: val.seriesCode,
                    datas: val.datas.map((item) => ({
                      imageUrl: item.teamLogo,
                      id: item.teamId,
                      shortName: item.shortName,
                    })),
                  }
                })
              : []
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getBasketballTeamGroup(stageCode) {
      let params = {
        sid: this.currSid,
        cid: this.currCid,
      }
      if (stageCode) {
        params.stageCode = stageCode
      }
      await https_seasonCup_teamList(this.axiosBaseUrl, this.$axios, params)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            if (!res.data || (res.data && res.data.length == 0)) {
              this.isNotDataFlag = true
            }
            this.cup_teamList = res.data
              ? res.data.map((val) => {
                  return {
                    title: val.seriesName,
                    key: val.seriesCode,
                    datas: val.teams.map((item) => ({
                      imageUrl: item.teamLogo,
                      id: item.teamId,
                      shortName: item.teamAbbr,
                    })),
                  }
                })
              : []
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#cup_team {
  .abs_topArea {
    position: absolute;
    top: 8vw;
    left: 0;
    z-index: 10;
    padding: 2vw 0 0 9.722vw;
    width: 100%;
    height: 8.68vw;
    font-size: 3vw;
    line-height: 6.68vw;
    color: var(--mixtmt_whiteColor);
    background-image: var(--mixtmt_detail_banner);
    background-size: 100% auto;
    background-position: center;
    background-repeat: no-repeat;
    object-fit: contain;
  }
  .select_area {
    position: relative;
    padding-top: 2.778vw;
    width: 100%;
    height: 9.028vw;
  }
  .teamList_area {
    width: 100%;
    padding: 2.083vw 0 2.778vw;
  }
}
.mixtmt_pc #cup_team,
.mixtmt_ipad #cup_team {
  padding: 8.68vw 0 0;
}
</style>
